export const FILE_SIZE_LIMITS = {
  MIN_SIZE: 20000, // 20KB
  MAX_SIZE: 10000000, // 10MB,
};

export const PHOTO_SIZE_LIMITS = {
  MIN_SIZE: 200000, //  200KB
  MAX_SIZE: 600000, // 600KB,
};

export const COMMON_FILE_TEXT = {
  SIZE_LIMIT: 'File size should be between 20KB and 10MB.',
  PHOTO_LIMIT: 'Photo size should be between 200KB and 600KB.',
};
